import { render, staticRenderFns } from "./_Register_old.vue?vue&type=template&id=37eeda98&scoped=true"
import script from "./_Register_old.vue?vue&type=script&lang=js"
export * from "./_Register_old.vue?vue&type=script&lang=js"
import style0 from "./_Register_old.vue?vue&type=style&index=0&id=37eeda98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37eeda98",
  null
  
)

export default component.exports